import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAll: function () {
    return axios.get(`${window.apiURL}api/user/artists`)
  },
  getAllRoyalities: function () {
    return axios.get(`${window.apiURL}api/user/artistsAll`)
  },
  get: function (id) {
    return axios.get(`${window.apiURL}api/user/artists/${id}`)
  },
  save: function (artist) {
    artist = JSON.parse(JSON.stringify(artist))

    if (artist._id) {
      let id = artist._id
      let data = artist

      delete artist._id
      delete artist.createdAt
      delete artist.updatedAt
      return axios.put(`${window.apiURL}api/user/artists/${id}`, data)
    } else {
      return axios.post(`${window.apiURL}api/user/artists`, artist)
    }
  },
  checkArtistName: function (artist, urlSearch) {
    return axios.get(`${window.apiURL}api/check-artist-name`, { params: { artist, urlSearch } })
  },
  getSpotifyArtist: function (id) {
    return axios.get(`${window.apiURL}api/spotify-artist/${id}`)
  },
  inactive: function (artistId) {
    return axios.put(`${window.apiURL}api/artists/inactive/${artistId}`)
  },
  getPublicArtist: function (key) {
    return axios.get(`${window.apiURL}api/artists/${key}`)
  },
  getPublicArtists: function (params) {
    return axios.get(`${window.apiURL}api/artists`, { params })
  },
  sendRequestSoundcloudWhitelist: function (data) {
    return axios.post(`${window.apiURL}api/soundcloud-whitelist`, data)
  },
  getRequestSoundcloudWhitelist: function (artistId) {
    return axios.get(`${window.apiURL}api/soundcloud-whitelist`, { params: { artistId } })
  },
  getProArtists: function () {
    return axios.get(`${window.apiURL}api/pro-artists`)
  },
  setFugaArtists: function () {
    return axios.get(`${window.apiURL}api/analytics/set-fuga-artists`)
  },
  submitApplication: function (data) {
    return axios.post(`${window.apiURL}api/artist-application`, data)
  },
  checkArtistNameSpotifyWatchlist: function (artist) {
    return axios.get(`${window.apiURL}api/spotify-watchlist`, { params: { artist } })
  },
  getSpotifyArtistIndiefy: function (id) {
    return axios.get(`${window.apiURL}api/spotify-artist-infiefy/${id}`)
  },
  setPaymentMethod (artistId, paymentMethod) {
    return axios.put(`${window.apiURL}api/user/artist/payment_method/${artistId}`, { payment_method: paymentMethod })
  }
}



// WEBPACK FOOTER //
// ./src/services/artists.js